import * as React from 'react'
import { NavigationContainerRef } from '@react-navigation/native'

const navigationRef = React.createRef<NavigationContainerRef>()
export default navigationRef
